import { render, staticRenderFns } from "./ReadyContentsSvg.vue?vue&type=template&id=ab401450"
import script from "./ReadyContentsSvg.vue?vue&type=script&lang=js"
export * from "./ReadyContentsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports